/**
 * store for ide
 */

import examApi from '../../api/exam'
import { showErr } from '../../scripts/message/index'
import {getQceitQuery} from "./ide";

const examData = {
  state: {
    context: null,
    examInfo: { ItemList: [], Exam: { ExamID: 0 } },
  },
  mutations: {
    SET_EXAMINFO: (state, examInfo) => {
      if (examInfo) {
        state.examInfo = examInfo
      } else {
        console.error('SET_EXAMINFO:', examInfo)
      }
    },
  },
  actions: {
    async getExamInfo({ commit }, { query, ifLoad }) {
      const ExamID = parseInt(getQceitQuery(query).examTId || '0', 10)
      if (!ExamID) {
        showErr(`getExamInfo err: ExamID: ${ExamID}`)
      }
      if (!ifLoad) {
        commit('SET_EXAMINFO', { ItemList: [], Exam: { ExamID }})
        return;
      }
      const res = await examApi.getInfoById(ExamID)
      if (res.Code === 0) {
        if (res.data) {
          commit('SET_EXAMINFO', res.data)
        } else {
          console.error('getExamInfo err0:', res)
        }
      } else {
        console.error('getQuestionInfo err:', res)
        showErr(`getExamInfo err: ${res.Code}-${res.Msg}`)
      }
    },
  },
  getters: {
    examInfo: state => state.examInfo,
  }
}

export default examData
